import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

export default {
  state: () => ({
    selectedAdditionalServicePricing: { additionalServiceParkourBasedPricingModels: [] },
    additionalServicePricings: [],
    clickedAdditionalServicePricingDescribe: false,
  }),

  mutations: {
    setSelectedAdditionalServicePricing(state, additionalServicePricing) {
      Vue.set(state, "selectedAdditionalServicePricing", additionalServicePricing);
    },
    setAdditionalServicePricings(state, additionalServicePricings) {
      Vue.set(state, "additionalServicePricings", additionalServicePricings);
    },
    setClickedAdditionalServicePricingDescribe(state, clickedAdditionalServicePricingDescribe) {
      Vue.set(state, "clickedAdditionalServicePricingDescribe", clickedAdditionalServicePricingDescribe);
    },
    setDefaultAdditionalServicePricingModule(state, clickedAdditionalServicePricingDescribe) {
      Vue.set(state, "selectedAdditionalServicePricing", { additionalServiceParkourBasedPricingModels: [] });
      Vue.set(state, "additionalServicePricings", []);
      Vue.set(state, "clickedAdditionalServicePricingDescribe", false);
    },
  },
  actions: {
    //TODO: load, update, create
    createAdditionalServicePricing: (context, request) => {
      //TODO: Loader start
      return axios
        .post(context.getters.getMcServiceUrl + "/additional-service-pricings/entity", request, {})
        .then((response) => {
          //TODO: Loader end
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadAdditionalServicePricings: (context) => {
      //TODO: Loader start
      return axios.get(context.getters.getMcServiceUrl + "/additional-service-pricings/entity").then((response) => {
        context.commit("setAdditionalServicePricings", response.data);
        return response.data;
      });
    },
    loadAdditionalServicePricing: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/additional-service-pricings/entity/" + request.id).then((response) => {
        context.commit("setSelectedAdditionalServicePricing", response.data);
        return response.data;
      });
    },
    loadPublishedAdditionalServicePricing: (context) => {
      //TODO: Loader start
      return axios.get(context.getters.getMcServiceUrl + "/additional-service-pricings/published").then((response) => {
        //TODO: Loader koyulacak
        context.commit("setAdditionalServicePricings", response.data);
        return response.data;
      });
    },
    loadAdditionalServicePricingHistory: (context, request) => {
      //TODO: Loader start
      return axios.post(context.getters.getMcServiceUrl + "/additional-service-pricings/history/search", request, {}).then((response) => {
        //TODO: Loader end
        return response.data;
      });
    },
    loadSelectedAdditionalServicePricingHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/additional-service-pricings/history/" + request.id, {}).then((response) => {
        return response.data;
      });
    },
    additionalServicePriceDefinition: (context, additionalServicePrice) => {
      return axios.get(context.getters.getServiceUrl + "/additional-service-pricings/history/" + additionalServicePrice.id, {}).then((response) => {
        return response.data;
      });
    },

    //TODO
    searchAdditionalServicePricingByStationId: (context, request) => {
      return axios.post(context.getters.getServiceUrl + "/additional-service-pricings/history/search", request, {}).then((response) => {
        return response.data;
      });
    },

    deleteAdditionalServicePricing: (context, additionalServicePricing) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/additional-service-pricings/entity/" + additionalServicePricing.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          additionalServicePricing.intents = intents;
          additionalServicePricing.intentId = response.data.id;
          return additionalServicePricing;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftAdditionalServicePricing: (context, additionalService) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/additional-service-pricings/draft/" + additionalService.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishAdditionalServicePricing: (context, additionalServicePricing) => {
      return axios.get(context.getters.getMcServiceUrl + "/additional-service-pricings/publish/" + additionalServicePricing.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },
    rejectAdditionalServicePricing: (context, additionalServicePricing) => {
      return axios.get(context.getters.getMcServiceUrl + "/additional-service-pricings/reject/" + additionalServicePricing.intentId).then((response) => {
        if (additionalServicePricing.intents[0].type === "DELETE_ADDITIONAL_SERVICE_PRICING") {
          additionalServicePricing.intents = null;
          additionalServicePricing.intentId = 0;
        } else if (additionalServicePricing.intents[0].type === "CREATE_ADDITIONAL_SERVICE_PRICING") {
          additionalServicePricing.intents[0].status = "DRAFT";
        } else if (additionalServicePricing.intents[0].type === "UPDATE_ADDITIONAL_SERVICE_PRICING") {
          additionalServicePricing.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },
    sendToApprovalAdditionalServicePricing: (context, additionalServicePricing) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/additional-service-pricings/sendToApproval/" + additionalServicePricing.intentId)
        .then((response) => {
          if (additionalServicePricing.intents[0].type === "CREATE_ADDITIONAL_SERVICE_PRICING") {
            additionalServicePricing.intents[0].status = "WAITING_APPROVAL";
          } else if (additionalServicePricing.intents[0].type === "UPDATE_ADDITIONAL_SERVICE_PRICING") {
            additionalServicePricing.intents[0].status = "WAITING_APPROVAL";
          }
          return response.data;
        });
    },
    recallAdditionalServicePricing: (context, additionalServicePricing) => {
      return axios.get(context.getters.getMcServiceUrl + "/additional-service-pricings/recall/" + additionalServicePricing.intentId).then((response) => {
        helper.recallOrRejectEntity(additionalServicePricing, "ADDITIONAL_SERVICE_PRICING");
        return response.data;
      });
    },
    cancelAdditionalServicePricing: (context, additionalServicePricing) => {
      return axios.get(context.getters.getMcServiceUrl + "/additional-service-pricings/cancel/" + additionalServicePricing.intentId).then((response) => {
        return response.data;
      });
    },
  },
  getters: {
    getSelectedAdditionalServicePricing: (state) => {
      return state.selectedAdditionalServicePricing;
    },
    getAdditionalServicePricings: (state) => {
      return state.additionalServicePricings;
    },
    getClickedAdditionalServicePricingDescribe: (state) => {
      return state.clickedAdditionalServicePricingDescribe;
    },
  },
};
